class Info_TI_TariffZones extends Tango.Component {
	widgetDidMount() {
		const ctrl = document.getElementById(this.root);

		document.querySelectorAll(".zonetable input[type='radio']").forEach(function (el) {
			el.addEventListener("change", function (e) {
				const letter = e.currentTarget.getAttribute('data-letter');
				const col = e.currentTarget.getAttribute('data-col');

				const h = document.querySelector(".zonetable .selectedheader div[data-col='" + col + "']");
				h.innerHTML = letter;
				h.style.backgroundColor = e.currentTarget.parentNode.style.backgroundColor;
			});
			el.addEventListener("mouseover", function (e) {
				if (e.buttons == 1) {
					e.currentTarget.checked = true;
					e.currentTarget.dispatchEvent(new Event("change"));
				}
			});
			el.addEventListener("mousedown", function (e) {
				ctrl.classList.add('editstate');
			});
			el.addEventListener("mouseup", function (e) {
				ctrl.classList.remove('editstate');
			});
		});
	}
};

Tango.registerComponent(Info_TI_TariffZones, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils
}));